export default __webpack_public_path__ + "static/media/desk05.3460ced5.jpg";